<template>
    <div class="c-avatar">
        <div class="c-avatar__circle">
           <span class="c-avatar__initials">{{initials}}</span>
        </div>

        <div class="c-avatar__info">
            <div class="c-avatar__name">
                {{user.name}}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters({
            user: 'user/get',
            initials: 'user/initials',
        })
    }
}
</script>
